var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(42, 171, 226, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(146, 221, 253, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M24.2,-28.5C32.1,-22.1,39.8,-15.3,42.7,-6.5C45.5,2.4,43.4,13.1,38.3,22.3C33.2,31.5,25.1,39.2,16.1,41.1C7.1,43.1,-2.9,39.2,-11.4,34.7C-19.9,30.1,-26.8,24.8,-31.8,17.7C-36.8,10.5,-39.8,1.5,-39.4,-8C-39,-17.5,-35.2,-27.4,-28,-33.9C-20.9,-40.3,-10.4,-43.3,-1.2,-41.9C8.1,-40.5,16.2,-34.8,24.2,-28.5Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    },
    stroke: "url(#sw-gradient)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/blob (3).de3ff7be5bf95bb54147e80fd3f55e6d.svg";
export { ForwardRef as ReactComponent };